let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cQBAR")).then(() => parcelRequire('2Cx9n'));